import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/simplifyFiltersOnPLP/show/showSelector';

export const showSimplifyFiltersOnPLPSelector = createSelector(
    isTestTargetReadySelector, showSelector,
    (isReady, show) => Boolean(isReady && show)
);
